import React from 'react'
import {Form, Input} from 'antd'

const BInput = ({label, fieldName, fieldNameRoot, rules, placeholder, Icon, disabled, type, required, password, email, style, white, hidden}) => {
  const fieldEnhanced = fieldNameRoot ? [fieldNameRoot, fieldName] : fieldName

  return (
    <div className='bInput' style={{display: hidden ? 'none' : undefined}}>
      {label && <label className='bInputLabel' htmlFor={fieldEnhanced}>{label}</label>}
      <div style={style} className={'bInputDiv' + (white ? ' white' : '')}>
        {Icon}
        <Form.Item
          name={fieldEnhanced}
          rules={rules ?? (
            email ? [
              {required: true, message: 'Please input your Email'},
              {type: 'email', message: 'The input is not valid Email'},
            ] : password ? [
              {required: true, message: 'Please input your password'},
            ] : required ? [
              {required: true, message: 'This field is required'},
            ] : []
          )}
        >
          <Input
            id={fieldEnhanced}
            type={type ?? password ? 'password' : 'text'}
            disabled={disabled}
            placeholder={placeholder ?? (placeholder !== false ? label : '')}
          />
        </Form.Item>
      </div>
    </div>
  )
}

export default BInput
